import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Retailers from './pages/Retailers';
import Orders from './pages/Orders';
import Products from './pages/Products';
import Payments from './pages/Payments';
import Tasks from './pages/Tasks';
import Analytics from './pages/Analytics';
import Users from './pages/Users';
import Profile from './pages/Profile';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="retailers" element={<Retailers />} />
            <Route path="orders" element={<Orders />} />
            <Route path="products" element={<Products />} />
            <Route path="payments" element={<Payments />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="users" element={<AdminRoute><Users /></AdminRoute>} />
            <Route path="profile" element={<Profile />} />
          </Route>
        </Routes>
      </Router>
      <ToastContainer position="top-right" />
    </AuthProvider>
  );
}

export default App;